import React from 'react'
import { CustomDivProps } from '@components/ui/Box/Box'
import styles from './Card.module.scss'
import cn from 'classnames'

const CardUi: React.FC<CustomDivProps> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.container, className)} {...props}>
      {children}
    </div>
  )
}

export default CardUi
